import React, { Component } from 'react'
import '../../../App.css';
import './index.css'
import { Layout, Affix, Button, Icon, Anchor } from 'antd';
import "animate.css";
import { withTranslation } from 'react-i18next';
import SideBox from '../../cell/Side'
import image01 from '../../../assets/images/icon-01.png'
import * as images from './image'
const { Link } = Anchor;
const { Content, Sider } = Layout;
const handleClick = (e, link) => {
    e.preventDefault();
    console.log(link);
};
class Contentext extends Component {
    constructor(props) {
        super(props);
        this.state = {
            top: 85,
            bottom: 10,
            offsetTop: 80
        };
    }

    render() {
        const { t } = this.props
        return (
            <Content className="q-content-wrapper q-transparent">
                <div className="q-main" style={{ padding: '65px 0 20px 65px' }}>
                    <div className="q-fix-width">
                        <Layout>
                            <Content className="q-detail-content q-intro" style={{ paddingLeft: '10px' }}>
                                <Affix offsetTop={this.state.offsetTop}>
                                    <Anchor className="left-link" onClick={handleClick} offsetTop={this.state.top}>
                                        <Link href="#soft-introduce" title={t('header001')} />
                                        <Link href="#install-introduce" title={t('introItem01')} />
                                        <Link href="#basic-function" title={t('introItem02')} />
                                        <Link href="#my-scp" title={t('introItem09')} />
                                        <Link href="#API" title={t('introItem03')} />
                                        <Link href="#Anchor-Props" title={t('introItem04')} />
                                        <Link href="#knowledge" title={t('introItem05')} />
                                        <Link href="#textService" title={t('introItem06')} />
                                        <Link href="#infomation-center" title={t('introItem07')} />
                                        <Link href="#system-operation" title={t('introItem08')} />
                                        {/* <Link href="#future-service" title="未来服务" /> */}
                                    </Anchor>
                                </Affix>
                                <div className="right-content" id="soft-introduce">
                                    <h2>{t('header001')}</h2>
                                    <div className="right-content-box" >
                                        <div className="clearfix"><h3>{t('introItem01_01')}</h3></div>
                                        <p className="headTitle">{t('introItem01_02')}</p>
                                        <p>{t('introItem01_03')}</p>
                                        <p>{t('introItem01_04')}</p>
                                        <div className="clearfix"><h3>{t('introItem01_05')}</h3></div>
                                        <p>{t('introItem01_06')}</p>
                                        <div className="sep-image" >
                                            <img style={{ width: '100%' }} src={image01} alt="" />
                                        </div>
                                    </div>
                                    <h2 id="install-introduce" >{t('introItem01')}</h2>
                                    <div className="right-content-box" >
                                        <h4>一.{t('introItem02_01')}</h4>
                                        <p className="headTitle">1.{t('introItem02_02')}</p>
                                        <img src={images.installIntro01} alt=""  width="700"/>
                                        <p className="headTitle">2.{t('introItem02_05')}<b>【{t('caption')}】</b>{t('introItem02_06')}</p>
                                        <img src={images.installIntro02} alt="" />
                                        <h4>二.{t('introItem02_07')}</h4>
                                        <p className="headTitle">1.{t('introItem02_08')}</p>
                                        <p>{t('introItem02_09')}<b>{t('introItem02_10')}</b>{t('introItem02_11')}</p>
                                        <img src={images.installIntro03} alt="" />
                                        <p>{t('introItem02_12')}{t('introItem02_10')}{t('introItem02_13')}：</p>
                                        {/* <p>A.<b>{t('introItem02_12')}</b></p>
                                        <p>B.<b>{t('introItem02_13')}</b>{t('introItem02_14')}</p> 
                                        <img src={images.installIntro04} alt="" />
                                        */}
                                        <p>1.1.{t('introItem02_15')}</p>
                                        <p>{t('introItem02_15_1')}<b>{t('introItem02_16')}</b></p>
                                        <img src={images.installIntro05} alt="" />
                                        <p> 
                                        {t('introItem02_17')}<b>{t('introItem02_18')}</b>{t('introItem02_19')}
                                        </p>
                                        <img src={images.installIntro06} alt="" />
                                        <p>1.2{t('introItem02_20')}</p>
                                        <p>{t('introItem02_21')}<b>{t('introItem02_22')}</b>{t('introItem02_23')}</p>
                                        <img src={images.installIntro07} alt="" />
                                        <p>{t('introItem02_24')}<b className="warningInfo">{t('introItem02_25_1')}</b>
                                        {t('introItem02_25_2')}<b className="warningInfo">{t('introItem02_25_3')}</b>
                                        {t('introItem02_26')}{t('introItem02_18')}
                                        {t('introItem02_27')}</p>
                                        <p>{t('introItem02_28')}</p>
                                         <img src={images.installIntro08} alt="" />
                                        <p className="headTitle">2.{t('introItem02_29')}</p>
                                        <p>在{t('introItem02_30')}{t('introItem02_31')}{t('introItem02_32')}{t('introItem02_33')}</p>
                                        <img src={images.installIntro11_1} alt="" />
                                        <img src={images.installIntro11} alt="" />
                                        <p className="headTitle">3.{t('introItem02_34')}</p>
                                        <p><b>方法一:</b>{t('introItem02_37')}</p>
                                        <p>{t('introItem02_37_1')}：</p>
                                        <p>1.{t('introItem02_38')}</p>
                                        <p>{t('introItem02_39')}</p>
                                        <p>2.{t('introItem02_40')}</p>
                                        <p>{t('introItem02_41')}</p>
                                        <img src={images.installIntro13} alt="" />
                                        <img src={images.installIntro14} alt="" />
                                        <p><b>方法二:</b>{t('introItem02_35')}<b>【退出】</b>{t('introItem02_36')}</p>
                                        <img src={images.installIntro12} alt="" />
                                       {/* <p><b>方法三:</b>{t('introItem02_add_36')}</p>
                                        <img src={images.installIntro12_01} alt=""/>*/}
                                    </div>
                                    <h2 id="basic-function">{t('introItem02')}</h2>
                                    <div className="right-content-box">
                                        <h4>1.1.{t('introItem03_02')}</h4>
                                        <p>{t('introItem03_01')}</p>
                                        <img src={images.basicFun01} alt="" />
                                        <h4>1.2.{t('introItem03_17')}</h4>
                                        <p>{t('introItem03_03')}</p>
                                        <img src={images.basicFun02 } alt="" />
                                        <p><b>{t('introItem02_16')}：</b>{t('introItem03_04')}</p>
                                        <p>{t('introItem03_04_1')}</p>
                                        <img src={images.basicFun03 } alt="" />
                                        <p><b>{t('introItem03_05')}：</ b>{t('introItem03_06')}</p>
                                        <p>1.{t('introItem02_38')}</p>
                                        <p>{t('introItem02_39')}</p>
                                        <p>2.{t('introItem02_40')}</p>
                                        <p>{t('introItem02_41')}</p>
                                        <img src={images.basicFun04} alt="" />
                                        <p><b>{t('introItem03_07')}：</b>{t('introItem03_08')}</p>
                                        <img src={images.basicFun05} alt="" />
                                        <p><b>{t('introItem03_09')}：</b>{t('introItem03_10')}</p>
                                        <img src={images.basicFun06} alt="" />
                                        <p><b>{t('introItem03_11')}：</b>{t('introItem03_12')}</p>
                                        <img src={images.basicFun07} alt="" />
                                        <p><b>{t('introItem03_13')}：</b>{t('introItem03_14')}</p>
                                        <img src={images.basicFun08} alt="" />
                                        <p><b>{t('introItem03_15')}：</b>{t('introItem03_16')}</p >
                                        <img src={images.basicFun09} alt="" />
                                        <h4>1.3.{t('introItem03_17_01')}</h4>
                                        <p>{t('introItem03_18')}</p>
                                        <img src={images.basicFun10} alt="" />
                                        <p><b>{t('introItem03_19')}：</b>{t('introItem03_20')}
                                       {t('introItem03_20_1')}</p>
                                        <img src={images.basicFun1101} alt="" />                                        
                                        <p><b>{t('introItem03_21')}：</b>{t('introItem03_22')}</p>
                                        <img src={images.basicFun12} alt="" style={{width:'100%'}}/>
                                        <p><b>{t('introItem03_23')}：</b>{t('introItem03_24')}</p>
                                        <img src={images.basicFun13} alt="" style={{width:'100%'}}/>
                                        <p><b>{t('introItem03_25')}：</b>{t('introItem03_26')}</p>
                                        <img src={images.basicFun14} alt="" style={{width:'100%'}}/>
                                    </div>
                                    <h2 id="my-scp">{t('introItem09')}</h2>
                                    <div className="right-content-box">
                                        <p>{t('introItem10_01')}{t('introItem10_01_01')}</p>
                                        <img src={images.myscpg01} alt="" />
                                        <h4>1.{t('introItem10_02')}</h4>
                                        <p>{t('introItem10_02_01')}<a href="#knowledge">{t('introItem10_02_02')}</a>{t('introItem10_02_03')}</p>
                                        <p>1.1{t('introItem10_03')}</p>
                                        <img src={images.myscpg02 } alt="" />
                                        <p>1.2{t('introItem10_04')}</p>
                                        <img src={images.myscpg03 } alt="" width="700"/>
                                        <p>1.3{t('introItem10_05')}</p>
                                        <p>{t('introItem10_06')}</p>
                                        <img src={images.myscpg04 } alt="" width="700"/>
                                        <h4>2.{t('introItem10_07')}</h4>
                                        <p>{t('introItem10_08')}<a href="#Anchor-Props">{t('introItem10_08_1')}</a>{t('introItem10_02_03')}</p>
                                        <p>2.1{t('introItem10_08_2')}</p>
                                        <img src={images.myscpg05 } alt="" />
                                        <img src={images.myscpg06 } alt="" />
                                    </div>
                                    <h2 id="API">{t('introItem03')}</h2>
                                    <div className="right-content-box" >
                                        <h4>一.{t('introItem04_01')}</h4> 
                                        <p>{t('introItem04_02')}</p>
                                        {/* <p>1.{t('introItem04_03')}</p>
                                        <p>{t('introItem04_04')}</p>
                                        <p>2.{t('introItem04_05')}</p>
                                        <p>{t('introItem04_06')}</p>
                                        <p>3.{t('introItem04_11')}</p>
                                        <p>{t('introItem04_12')}</p> */}
                                        <img src={images.wiring01} alt=""  width="700"/>
                                        
                                        <p>1.{t('introItem04_03')}</p>
                                        <p>{t('introItem04_04')}</p>
                                      <img src={images.wiring02} alt="" />
                                        <p style={{ height: '40px'  }}></p>
                                        <p>{t('introItem04_05')}</p>
                                       <img src={images.wiring0201} alt="" />
                                       <p style={{ height: '40px'  }}></p>
                                       <p><b className="warningInfo">{t('introItem04_06')}</b></p>
                                       <img src={images.wiring0202} alt="" />
                                       <p style={{ height: '40px'  }}></p>
                                       <p>2.{t('introItem04_07')}</p>
                                       <p>{t('introItem04_08')}</p>
                                       <p>{t('introItem04_09')}</p>
                                       <p><b className="warningInfo">{t('introItem04_10')}</b></p>
                                       <p>{t('introItem04_11')}</p>
                                       <img src={images.wiring0203} alt="" />
                                       <img src={images.wiring0204} alt="" />
                                       <p style={{ height: '40px'  }}></p>
                                       <p>{t('introItem04_12')}</p>
                                       <img src={images.wiring0205} alt="" />
                                    </div>
                                    <h2 id="Anchor-Props">{t('introItem04')}</h2>
                                    <div className="right-content-box" >
                                        <h4>一.{t('introItem05_01')}</h4>
                                        <p>{t('introItem05_02')}</p>
                                        <p>{t('introItem05_03')}<b>{t('introItem05_04')}，</b>{t('introItem05_05')}</p>
                                        <img src={images.caseManage02} alt="" />
                                        <h4>二.{t('introItem05_06')}</h4>
                                        <p>{t('introItem05_0602')}</p>
                                        <p>1.{t('introItem05_08')}</p>
                                        <p>{t('introItem05_09')}</p>
                                        <img src={images.caseManage04} alt="" />
                                        <p>2.{t('introItem05_10')}</p>
                                        <p>A.{t('introItem05_11')}：</p>
                                        <p>{t('introItem05_12')}<b>{t('introItem05_13')}</b>{t('introItem05_14')}<b>{t('introItem05_14_1')}</b>{t('introItem05_14_2')}</p>
                                        <p>B.{t('introItem05_15')}：</p>
                                        <p>{t('introItem05_16')}</p>
                                        <p>C.{t('introItem05_17')}：</p>
                                        <p>{t('introItem05_18')}</p>
                                        <img src={images.caseManage05} alt="" />
                                        <p>3.{t('introItem05_19')}</p>
                                        <img src={images.caseManage06} alt="" width="700"/>
                                        <p>{t('introItem05_19_1')}</p>
                                        <p>{t('introItem05_19_2')}</p>
                                        <img src={images.caseManage07} alt="" width="700"/>
                                        <h4>三.{t('introItem05_20')}</h4>
                                        <p>{t('introItem05_21')}<b>【{t('introItem05_20')}】</b>{t('introItem05_22')}</p>
                                        <p>{t('introItem05_23')}</p>
                                        <img src={images.caseManage08} alt="" />
                                        <img src={images.caseManage09} alt="" />
                                        <p>{t('introItem05_25')}<b>{t('introItem05_26')}</b>{t('introItem05_27')}</p>
                                        <img src={images.caseManage10} alt="" />
                                        <img src={images.caseManage11} alt="" />
                                       
                                       {/*} <p>{t('introItem05_24')}</p>
                                        <img src={images.caseManage12} alt="" />*/}
                                        <p>{t('introItem05_28')}</p>
                                        <img src={images.caseManage13} alt="" />
                                       
                                    </div>
                                    <h2 id="knowledge">{t('introItem05')}</h2>
                                    <div className="right-content-box" >
                                        <h4>一.{t('introItem06_01')}</h4>
                                        <p>{t('introItem06_02')}</p>
                                        {/* <p><b>{t('introItem06_03')}</b>：{t('introItem06_04')}</p> */}
                                        <p><b>{t('introItem06_05')}</b>：{t('introItem06_06')}</p>
                                        <p><b>{t('introItem06_0502')}</b>：{t('introItem06_0602')}</p>
                                        {/* <p><b>{t('introItem06_07')}</b>：{t('introItem06_08')}</p>
                                        <p><b>{t('introItem06_09')}</b>：{t('introItem06_10')}</p>
                                        <p><b>{t('introItem06_11')}</b>：{t('introItem06_12')}</p>
                                        <p><b>{t('introItem06_13')}</b>：{t('introItem06_14')}</p> */}
                                        <p><b>{t('introItem06_15')}</b>：{t('introItem06_16')}</p>
                                        <img src={images.powerkm01} alt="" width="700"/>
                                        <h4>二.{t('introItem06_17')}</h4>
                                        <p>1.{t('introItem06_18')}</p>
                                        <img src={images.powerkm02} alt="" width="700"/>
                                        <p>2.{t('introItem06_19')}</p>
                                        <p>{t('introItem06_20')}<b>【影音】</b>{t('introItem06_21')}</p>
                                        <img src={images.powerkm03} alt="" width="700"/>
                                        <img src={images.powerkm04} alt="" width="700"/>
                                        <p>{t('introItem06_22')}<b>【我的管家】</b>{t('introItem06_23')}<b>{t('introItem06_23_1')}</b>{t('introItem06_23_2')}</p>
                                        <img src={images.powerkm05} alt="" width="700"/>
                                        <h4>三.{t('introItem06_24')}</h4>
                                        <p>{t('introItem06_25')}<b>【收藏】</b>{t('introItem06_26')}</p>
                                        <img src={images.powerkm06} alt="" width="700"/>
                                        <h4>四.{t('introItem06_27')}</h4>
                                        <p>{t('introItem05_12')}<b>【我的收藏】</b>{t('introItem06_28')}</p>
                                        <img src={images.powerkm07} alt="" width="700"/>
                                        <h4>五.{t('introItem06_29')}</h4>
                                        <p>A.{t('introItem06_30')}</p>
                                        <img src={images.powerkm08} alt="" width="700"/>
                                        <img src={images.powerkm09} alt="" width="700"/> 
                                        <p>B.{t('introItem06_32')}<b>{t('introItem06_33')}</b>{t('introItem06_34')}</p>
                                        <img src={images.powerkm10} alt="" />
                                        <img src={images.powerkm11} alt="" width="700"/> 
                                    </div>
                                    <h2 id="textService">{t('introItem06')}</h2>
                                    <div className="right-content-box">
                                        <h4>一.{t('introItem07_01')}</h4>
                                        <p>{t('introItem07_02')}</p>
                                        <img src={images.intellectService01} alt="" />  
                                        <h4>二.{t('introItem07_03')}</h4>
                                        <p>1.{t('introItem07_04')}</p>
                                        <p>{t('introItem07_05')}</p>
                                        <img src={images.intellectService02} alt="" width="700"/>  
                                        <p>2.{t('introItem05_12')}<b>【智能客服】</b>{t('introItem07_06')}</p>
                                        <img src={images.intellectService03} alt="" width="700"/>  
                                        <p>3.{t('introItem07_07')}</p>
                                        <img src={images.intellectService04} alt="" width="700"/>
                                        <p>{t('introItem07_0702')}</p>
                                        <img src={images.intellectService0402} alt="" width="700"/>   
                                        {/* <p>4.{t('introItem07_08')}<b>{t('introItem07_09')}</b>{t('introItem07_10')}</p>
                                        <img src={images.intellectService05} alt="" />  
                                        <img src={images.intellectService06} alt="" />   */}
                                    </div> 
                                    <h2 id="infomation-center">{t('introItem07')}</h2>
                                    <div className="right-content-box">
                                        <h4>{t('introItem08_01')}</h4>
                                        <p>{t('introItem08_02')}</p>
                                        <p><b>{t('introItem08_03')}</b>：{t('introItem08_04')}</p>
                                        <p><b>{t('introItem08_05')}</b>：{t('introItem08_06')}</p>
                                        <p><b>{t('introItem08_07')}</b>：{t('introItem08_08')}</p>
                                        <p><b>{t('introItem08_09')}</b>：{t('introItem08_10')}</p>
                                        <p><b>{t('introItem08_11')}</b>：{t('introItem08_12')}</p>
                                        <p><b>{t('introItem08_13')}</b>：{t('introItem08_14')}</p>
                                        <p><b>{t('introItem08_19')}</b>：{t('introItem08_20')}</p>
                                        <p><b>{t('introItem08_15')}</b>：{t('introItem08_16')}</p>
                                        <p><b>{t('introItem08_1502')}</b>：{t('introItem08_1602')}</p>
                                        {/* <p><b>{t('introItem08_17')}</b>：{t('introItem08_18')}</p> */}
                                        {/* <p>{t('introItem08_21')}<a href="https://service.digiwin.com/custom_service_manual">{t('introItem08_22')}</a></p> */}
                                        <img src={images.news01} alt="" width="700"/>   
                                    </div>
                                    <h2 id="system-operation">{t('introItem08')}</h2>
                                    <div className="right-content-box" >
                                        <h4>{t('introItem09_001')}</h4>
                                        <p >{t('introItem09_01')}</p>
                                        <img src={images.sys01} alt="" width="700"/> 
                                    </div>
                                </div>
                            </Content>
                            <Sider theme="light" className="q-detail-sider">
                                <SideBox type='3' />
                            </Sider>
                        </Layout>
                    </div>
                </div>
            </Content>
        )
    }
}
export default withTranslation()(Contentext)